import React, { useEffect, useState } from 'react';
import { Modal } from '@/pages/common/Modal';
import * as Styles from './PromotionBanner.styles';
import { Button } from 'gatorcomponents';
import bannerDesktopBr from './images/desktop-modal-br.png';
import bannerDesktopEs from './images/desktop-modal-es.png';
import useLocale from '@/hooks/useLocale';
import { useSelector } from 'react-redux';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { PROMOTION_BANNER } from '@/config/GrowthBook/constants';
import { isBRServer } from '@/utils/Validators/validation';

const PromotionBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { videoClasses: videoClassesLocale } = useLocale();
  const { liveData, liveDataRequested } = useSelector(state => state.videoClassesReducer);
  const canShowPromotionBanner = useFeatureIsOn(PROMOTION_BANNER);
  const liveIsRunning = liveData && liveData.liveID;
  const isOnboarding = window.location.pathname.includes('onboarding');
  const isInsideWizard = window.location.pathname.includes('/criar-site') || window.location.pathname.includes('/crear-sitio-web');
  const bannerImage = isBRServer ? bannerDesktopBr : bannerDesktopEs;

  useEffect(() => {
    const notShowPromotionBanner = localStorage.getItem('notShowHostGatorConectaPromotionBanner');
    if (!notShowPromotionBanner && liveDataRequested && !liveIsRunning) {
      setShowBanner(true);
    }
  }, [liveIsRunning, liveDataRequested]);

  const onClose = () => {
    setShowBanner(false);
  };

  const notShowAgain = () => {
    setShowBanner(false);
    localStorage.setItem('notShowHostGatorConectaPromotionBanner', 'true');
  };

  const handleBannerClick = () => {
    if (isBRServer) {
      window.open('https://lp.hostgator.com.br/1e2e80Yd/hostgator-conecta?utm_source=produtos&utm_medium=portal-do-cliente&utm_campaign=banner', '_blank');
    } else {
      window.open('https://lp.hostgator.com.br/1e4e80Yd/hostgator-conecta?utm_source=produtos&utm_medium=portal-do-cliente&utm_campaign=banner', '_blank');
    }
  };

  const canShowBanner = canShowPromotionBanner && showBanner && !liveIsRunning && (!isOnboarding || !isInsideWizard);

  return (
    <>
      {canShowBanner && (
        <Modal
          maxWidth={800}
          maxHeight={440}
          testId="promotion-banner"
          disablePadding
          onCloseButtonAction={onClose}
        >
          <Styles.NotShowAgain>
            <Button
              label={videoClassesLocale.notShowAgainLabel}
              onClick={notShowAgain}
              variant="secondary"
              size="small"
            />
          </Styles.NotShowAgain>
          <Styles.Content
            onClick={handleBannerClick}
            bannerImage={bannerImage}
          />
        </Modal>
      )}
    </>
  );
};
export default PromotionBanner;
